import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  createTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  deleteProvincia,
  getProvinciaById,
  postProvincia,
  updateProvincia,
} from "../../../../api/provincia";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getCountries } from "../../../../api/country";
import { Autocomplete } from "@material-ui/lab";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyProvincia() {
  return {
    fullName: "",
    pais: "",
  };
}

export default function EditProvinciasPage() {
  const [province, setProvince] = useState(getEmptyProvincia());
  const [countries, setCountries] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const provinceId = useParams().id;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    getCountries()
      .then((res) => {
        setCountries(res.data);
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se han podido obtener los países.",
        });
        history.push("/provinces");
      });

    if (!provinceId) {
      disableLoadingData();
      return;
    }

    getProvinciaById(provinceId)
      .then((res) => {
        setProvince(res.data);
        disableLoadingData();
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "No se ha podido obtener la provincia.",
        });
        history.push("/provinces");
      });
  }, [provinceId, disableLoadingData, history]);

  function saveProvincia() {
    if (!province.fullName?.trim())
      return alertError({
        error: null,
        customMessage: "El nombre de la provincia es obligatorio.",
      });
    if (!provinceId && !province.pais)
      return alertError({
        error: null,
        customMessage: "Selecciona un país.",
      });
    if (!provinceId) {
      postProvincia(province)
        .then((res) => {
          alertSuccess({
            title: "Guardado!",
            customMessage: "Province saved correctamente.",
          });
          history.push("/provinces");
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se ha podido guardar la provincia.",
          });
        });
    } else {
      updateProvincia(provinceId, province)
        .then((res) => {
          alertSuccess({
            title: "Guardado!",
            customMessage: "Changes saved correctamente.",
          });
          history.push("/provinces");
        })
        .catch((error) => {
          alertError({
            error: error,
            customMessage: "No se han podido guardar los cambios.",
          });
        });
    }
  }

  const handleChange = (element) => (event) => {
    setProvince({ ...province, [element]: event.target.value });
  };

  if (isLoadingData)
    return <ContentSkeleton />;

  return (
    <>
      <Card>
        <CardHeader title="Editar provincia"></CardHeader>
        <CardBody>
          <div className="d-flex align-item-center">
            <div className="col-4">
              <TextField
                label="Nombre provincia"
                value={province.fullName}
                onChange={handleChange("fullName")}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
            <div className="col-4">
              <Autocomplete
                id='Countries'
                options={countries}
                value={province.pais || null}
                getOptionLabel={(option) => option.name}
                onChange={(_, newValue) => {
                  setProvince({
                    ...province,
                    pais: newValue,
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label='País'
                    margin="normal"
                    variant="outlined"
                  />
                )}
              />
            </div>
          </div>

        </CardBody>
      </Card>

      <Button
        onClick={() => history.push("/provinces")}
        variant="outlined"
        style={{ marginRight: "20px" }}
      >
        Atrás
      </Button>

      <Button
        onClick={() => saveProvincia()}
        variant="outlined"
        color="primary"
        style={{ marginRight: "20px" }}
      >
        Guardar provincia
      </Button>

      {provinceId && (
        <>
          <MuiThemeProvider theme={theme}>
            <Button
              onClick={() => setOpenConfirmDialog(true)}
              variant="outlined"
              color="secondary"
            >
              Eliminar provincia
            </Button>
          </MuiThemeProvider>

          <ConfirmDialog
            title={"Seguro que quieres eliminar esta provincia?"}
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            onConfirm={() => {
              deleteProvincia(provinceId)
                .then((res) => {
                  alertSuccess({
                    title: "Eliminado!",
                    customMessage: "Province deleted correctamente.",
                  });
                  history.push("/provinces");
                })
                .catch((error) => {
                  alertError({
                    error: error,
                    customMessage: "No se ha podido eliminar la provincia.",
                  });
                });
            }}
          />
        </>
      )}
    </>
  );
}
